import { render, staticRenderFns } from "./QcentrisUnitTurnover.vue?vue&type=template&id=b6daac32&scoped=true&"
import script from "./QcentrisUnitTurnover.vue?vue&type=script&lang=js&"
export * from "./QcentrisUnitTurnover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6daac32",
  null
  
)

export default component.exports